export default "__VITE_ASSET__DjpQLKPT__"